import React, { Component } from "react";
import { connect } from "react-redux";
import getConfig from "next/config";
import Head from "next/head";

const {
  publicRuntimeConfig: { credex, settings },
} = getConfig();

import { submitOnlineCreditRequest } from "@store/financing-solutions/actions";
import { getCredexPageConfig } from "@store/credex/actions";
import OnlineCreditContainer from "@containers/FinancingSolutions/OnlineCredit";
import ErrorPage from "@containers/ErrorPage";

import { getCmsBlocks } from "@store/app/actions";
import { makeApiCall } from "@lib/api/helpers";
import { getBannersV2Api } from "@lib/api";
import transformV2Banners from "@lib/transformV2Banners";

// TODO banner id for brico
const BANNER_ID = settings.websiteName === "altex" ? 47 : 48;
class OnlineCredit extends Component {
  static async getInitialProps(ctx) {
    const { reduxStore } = ctx;

    await reduxStore.dispatch(
      getCmsBlocks(["solutii-finantare_credit-online_txt"])
    );

    const credexPageConfig = reduxStore.getState().credex.page;
    if (!credexPageConfig) {
      await reduxStore.dispatch(getCredexPageConfig());
    }

    const banner = await makeApiCall({
      apiCall: getBannersV2Api,
      apiArgs: [{ id: BANNER_ID }],
      formatResponse: (response) => response.data,
      returnResponse: true,
    });

    return banner ? { banner: transformV2Banners(banner) } : null;
  }

  render() {
    const { customer, submitOnlineCreditRequest, credexPageConfig, banner } =
      this.props;

    if (credex.isEnabled) {
      return (
        <>
          <Head>
            <title>{`Credit online`}</title>
          </Head>

          <OnlineCreditContainer
            customer={customer}
            onFormSubmit={submitOnlineCreditRequest}
            cmsBlocks={this.props.cmsBlocks}
            credexPageConfig={credexPageConfig}
            banner={banner}
          />
        </>
      );
    }

    // Store data incomplete
    return <ErrorPage>{`Pagina este indisponibila temporar.`}</ErrorPage>;
  }
}

OnlineCredit.pageLayout = "default";

export default connect(
  (state) => ({
    cmsBlocks: state.app.cmsBlocks,
    customer: state.user.customer,
    credexPageConfig: state.credex.page,
  }),
  {
    submitOnlineCreditRequest,
  }
)(OnlineCredit);
